<script>
export default {
    name: "IconBook"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 49 48" fill="none">
        <path
            d="M24.334 19.5996V39.9996M24.334 19.5996C24.334 16.2393 24.334 14.5598 24.9879 13.2764C25.5632 12.1474 26.4804 11.2292 27.6094 10.654C28.8928 10 30.5733 10 33.9336 10H39.1336C40.2537 10 40.8141 10 41.242 10.218C41.6183 10.4097 41.9235 10.7155 42.1152 11.0918C42.3332 11.5196 42.334 12.0801 42.334 13.2002V30.8002C42.334 31.9203 42.3332 32.4796 42.1152 32.9074C41.9235 33.2837 41.6189 33.5905 41.2426 33.7822C40.8152 34 40.256 34 39.1381 34H33.4727C31.5942 34 30.6533 34 29.8008 34.2589C29.046 34.4881 28.3453 34.8634 27.736 35.3643C27.0476 35.93 26.526 36.7115 25.4841 38.2744L24.334 39.9996M24.334 19.5996C24.334 16.2393 24.3336 14.5598 23.6797 13.2764C23.1044 12.1474 22.1865 11.2292 21.0575 10.654C19.7741 10 18.0935 10 14.7332 10H9.5332C8.4131 10 7.8536 10 7.42578 10.218C7.04946 10.4097 6.74372 10.7155 6.55197 11.0918C6.33398 11.5196 6.33398 12.0801 6.33398 13.2002V30.8002C6.33398 31.9203 6.33398 32.4796 6.55197 32.9074C6.74372 33.2837 7.04946 33.5905 7.42578 33.7822C7.85319 34 8.412 34 9.52992 34H15.1954C17.0739 34 18.0128 34 18.8654 34.2589C19.6201 34.4881 20.3242 34.8634 20.9336 35.3643C21.6191 35.9277 22.1374 36.7052 23.1709 38.2555L24.334 39.9996"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
